import { type ComponentPropsWithRef, type Ref } from 'react';

import { classNames } from '../../internal/classNames';

export type DividerOrientation = 'Horizontal' | 'Vertical';

export type DividerProps = Omit<ComponentPropsWithRef<'div'>, 'children'> & {
    orientation?: DividerOrientation;
    spaced?: boolean;
    invisible?: boolean;
    ref?: Ref<HTMLDivElement>;
};

const Divider = ({
    orientation = 'Horizontal',
    spaced = false,
    invisible = false,
    className = '',
    ref,
    ...rest
}: DividerProps) => {
    const isVertical = orientation === 'Vertical';

    return (
        <div
            {...rest}
            ref={ref}
            role='separator'
            aria-orientation={isVertical ? 'vertical' : 'horizontal'}
            aria-hidden={invisible || undefined}
            className={classNames({
                'ui-divider': true,
                'ui-divider--vertical': isVertical,
                'ui-divider--spaced': spaced,
                'ui-divider--invisible': invisible,
                [className]: Boolean(className),
            })}
        />
    );
};

Divider.displayName = 'Divider';

export default Divider;
